<template>
    <div class="con">
        <div class="banner">
            <img src="../assets/yr/pbanner.png" alt="">
        </div>
        <div class="main">
            <div class="mainCon">
                <div class="proList">
                                    <div class="oneItem" v-for="(item,index) in proList" :key="index">
                                            <router-link :to="{path: 'proInfo',query:{id:item.ID}}" target="_blank">
                                                <img :src="`http://www.yourlonglighting.com/upload/${item.SMALLPIC}`" alt="">
                                            <p class="t1">{{item.PRONAME}}</p>
                                            <div class="last">
                                                <p>{{item.TITLE2}}</p>
                                                <i class="iconfont icon-youjiantou"></i>
                                            </div>
                                            </router-link>
                                        </div>
                </div>
            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import {getOnePro} from '../util/lang'
    export default {
        name: "pro",
        data(){
            return{
                proList:[]
            }
        },
        components:{footComponent},
        mounted(){
            if(this.$route.query.value!==undefined){
                this.getProduct(this.$route.query.value)
            }
        },
        methods:{
            getProduct(n){
                this.$nextTick(()=>{
                    const url = `${getOnePro('zh-CN','60',n,1000,1)}`
                    this.$axios.get(url).then(res => {
                        this.proList=res.data.proarr
                    })
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    background-color: #F4F4F4;
    animation: down 2s linear;
    @keyframes down {
        from{
            transform: translateX(-30px);
        }
        to{
            transform: translateX(0);
        }
    }
    .banner{
    width:100%;
        overflow: hidden;
    img{
        width:100%;
        object-fit: cover;
        display: block;
        animation: big 1s linear forwards;
    }
        @keyframes big {
            from{
                transform: scale(1.1);
            }
            to{
                transform: scale(1);
            }
        }
}
    .main{
        width:100%;
        .mainCon{
            width:1280px;
            margin: 0 auto;
           padding: 40px 0;
            .proList{
                width:100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                .title{
                    width:100%;
                    text-align: center;
                    font-family: Calibri;
                    font-size: 30px;
                    text-transform: uppercase;
                    border-bottom: 1px solid #E2E2E2;
                    position: relative;
                    padding-bottom: 20px;
                }
                .title::after{
                    position: absolute;
                    content:'';
                    display: inline-block;
                    width:20%;
                    height:2px;
                    bottom:-1px;
                    left:40%;
                    background-color: rgba(0,0,0,.5);
                }
                .oneItem{
                    width:30%;
                    background-color: white;
                    text-align: center;
                    cursor: pointer;
                    margin-left: 2%;
                    margin-top: 50px;
                    transition: all 1s;
                    a{
                        display: inline-block;
                        width:100%;
                    }
                    img{
                        width:100%;
                        height:340px;
                        object-fit: cover;
                    }
                    p{
                        text-align: left;
                        width:80%;
                        margin-left: 10%;
                        font-family:Calibri;
                        text-transform: uppercase;
                    }
                    .t1{
                        font-size: 22px;
                        margin-block-end: 0;
                        transition: all 2s;
                        display: -webkit-box;
                        height:30px;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                    }
                    .last{
                        width:80%;
                        margin-left: 10%;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        i{
                            color:#696969;
                            font-size: 20px;
                            transition: all 2s;
                        }
                        p{
                            margin-block-start: 0.5em;
                            margin-left: 0;
                            color:#696969;
                        }
                    }
                }
                .oneItem:hover{
                    box-shadow:5px 5px 5px 5px #e2e2e2;
                    .t1{
                        color:#F4A000;
                    }
                    .last{
                        i{
                            color:#F4A000;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width:450px){
        .banner{
            img{
                height:200px;
            }
        }
        .main{
            width:95%;
            margin-left: 2.5%;
          .mainCon{
              width:100%;
              flex-direction: column;
              .left{
                  width:100%;
              }
              .proList{
                  .oneItem{
                      width:100%;
                      margin-left: 0;
                  }
              }
              .right{
                  width:100%;
                  margin-left: 0;
                  margin-top: 30px;
              }
          }
        }
    }
}
</style>
